// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AuratypesSoftwareSensitivity } from './AuratypesSoftwareSensitivity';
import {
  AuratypesSoftwareSensitivityFromJSON,
  AuratypesSoftwareSensitivityFromJSONTyped,
  AuratypesSoftwareSensitivityToJSON,
  AuratypesSoftwareSensitivityToJSONTyped,
} from './AuratypesSoftwareSensitivity';
import type { AuratypesComponentVersion } from './AuratypesComponentVersion';
import {
  AuratypesComponentVersionFromJSON,
  AuratypesComponentVersionFromJSONTyped,
  AuratypesComponentVersionToJSON,
  AuratypesComponentVersionToJSONTyped,
} from './AuratypesComponentVersion';
import type { AuratypesSoftwareCriticality } from './AuratypesSoftwareCriticality';
import {
  AuratypesSoftwareCriticalityFromJSON,
  AuratypesSoftwareCriticalityFromJSONTyped,
  AuratypesSoftwareCriticalityToJSON,
  AuratypesSoftwareCriticalityToJSONTyped,
} from './AuratypesSoftwareCriticality';
import type { AuratypesSoftwareDependency } from './AuratypesSoftwareDependency';
import {
  AuratypesSoftwareDependencyFromJSON,
  AuratypesSoftwareDependencyFromJSONTyped,
  AuratypesSoftwareDependencyToJSON,
  AuratypesSoftwareDependencyToJSONTyped,
} from './AuratypesSoftwareDependency';
import type { FieldExpression } from './FieldExpression';
import {
  FieldExpressionFromJSON,
  FieldExpressionFromJSONTyped,
  FieldExpressionToJSON,
  FieldExpressionToJSONTyped,
} from './FieldExpression';

/**
 *
 * @export
 * @interface AuratypesComponent
 */
export interface AuratypesComponent {
  /**
   *
   * @type {Array<FieldExpression>}
   * @memberof AuratypesComponent
   */
  clusterExpressions?: Array<FieldExpression>;
  /**
   *
   * @type {AuratypesSoftwareCriticality}
   * @memberof AuratypesComponent
   */
  criticality?: AuratypesSoftwareCriticality;
  /**
   *
   * @type {Array<AuratypesSoftwareDependency>}
   * @memberof AuratypesComponent
   */
  dependencies?: Array<AuratypesSoftwareDependency>;
  /**
   *
   * @type {Array<string>}
   * @memberof AuratypesComponent
   */
  excludedScoringAspects?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof AuratypesComponent
   */
  name?: string;
  /**
   *
   * @type {AuratypesSoftwareSensitivity}
   * @memberof AuratypesComponent
   */
  sensitivity?: AuratypesSoftwareSensitivity;
  /**
   *
   * @type {AuratypesComponentVersion}
   * @memberof AuratypesComponent
   */
  version?: AuratypesComponentVersion;
}

/**
 * Check if a given object implements the AuratypesComponent interface.
 */
export function instanceOfAuratypesComponent(
  value: object,
): value is AuratypesComponent {
  return true;
}

export function AuratypesComponentFromJSON(json: any): AuratypesComponent {
  return AuratypesComponentFromJSONTyped(json, false);
}

export function AuratypesComponentFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AuratypesComponent {
  if (json == null) {
    return json;
  }
  return {
    clusterExpressions:
      json['cluster_expressions'] == null
        ? undefined
        : (json['cluster_expressions'] as Array<any>).map(
            FieldExpressionFromJSON,
          ),
    criticality:
      json['criticality'] == null
        ? undefined
        : AuratypesSoftwareCriticalityFromJSON(json['criticality']),
    dependencies:
      json['dependencies'] == null
        ? undefined
        : (json['dependencies'] as Array<any>).map(
            AuratypesSoftwareDependencyFromJSON,
          ),
    excludedScoringAspects:
      json['excluded_scoring_aspects'] == null
        ? undefined
        : json['excluded_scoring_aspects'],
    name: json['name'] == null ? undefined : json['name'],
    sensitivity:
      json['sensitivity'] == null
        ? undefined
        : AuratypesSoftwareSensitivityFromJSON(json['sensitivity']),
    version:
      json['version'] == null
        ? undefined
        : AuratypesComponentVersionFromJSON(json['version']),
  };
}

export function AuratypesComponentToJSON(json: any): AuratypesComponent {
  return AuratypesComponentToJSONTyped(json, false);
}

export function AuratypesComponentToJSONTyped(
  value?: AuratypesComponent | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    cluster_expressions:
      value['clusterExpressions'] == null
        ? undefined
        : (value['clusterExpressions'] as Array<any>).map(
            FieldExpressionToJSON,
          ),
    criticality: AuratypesSoftwareCriticalityToJSON(value['criticality']),
    dependencies:
      value['dependencies'] == null
        ? undefined
        : (value['dependencies'] as Array<any>).map(
            AuratypesSoftwareDependencyToJSON,
          ),
    excluded_scoring_aspects: value['excludedScoringAspects'],
    name: value['name'],
    sensitivity: AuratypesSoftwareSensitivityToJSON(value['sensitivity']),
    version: AuratypesComponentVersionToJSON(value['version']),
  };
}
